import {APIv1} from '../../api'
import React, {useState, useEffect, useCallback} from 'react'
import {useOutletContext} from "react-router-dom";
import {extractDateBySecond} from "../../utils";
import {Table} from 'antd'
import EmailColumns from "./email.constants";
import {useTranslation} from "react-i18next";
import useUrlTableState from "../../hooks/useUrlTableState";
import ListStateIndicator from "../../components/ListStateIndicator/ListStateIndicator";

const EMAIL_FILTER_PARAM_MAP = {
    is_success: 'is_success',
};

const EMAIL_FILTER_LABELS = {
    is_success: 'Status',
};

const parseBooleanParam = (value) => value === 'true';

const EMAIL_FILTER_VALUE_PARSERS = {
    is_success: parseBooleanParam,
};

const Email = (props) => {
    let defaultPaginationSize = props.defaultPaginationSize !== undefined ? props.defaultPaginationSize : 20;

    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [EmailData, setEmailData] = useState([])
    const [totalEmail, setTotalEmail] = useState(0)
    const [startPeriod, setStartPeriod] = useState(0);
    const [endPeriod, setEndPeriod] = useState(0);
    const [loading, setLoading] = useState(true)
    const {searchText} = useOutletContext()
    const tableState = useUrlTableState({
        defaultPageSize: defaultPaginationSize,
        filterParamMap: EMAIL_FILTER_PARAM_MAP,
        filterValueParsers: EMAIL_FILTER_VALUE_PARSERS,
        filterLabels: EMAIL_FILTER_LABELS,
        searchText,
    });

    const handleChangePeriod = (value) => {
        if (value === null || value === 0) {
            setStartPeriod(0);
            setEndPeriod(0);
        } else {
            let startPeriod = value[0].format('YYYY-MM-DD');
            let endPeriod = value[1].add(1, 'days').format('YYYY-MM-DD');
            setStartPeriod(startPeriod);
            setEndPeriod(endPeriod);
        }
    }

    const columns = EmailColumns(t, handleChangePeriod);
    const controlledColumns = tableState.controlledColumns(columns);

    const fetchEmailData = useCallback(async (page, size, search = '', ordering = '', filters = {}) => {
        setLoading(true);
        try {
            const queryParams = {
                page,
                page_size: size,
                search,
                ordering,
                ...filters,
            };

            if (filters.period) {
                queryParams.period = filters.period;
            }

            let pre_url = '/email/list/';
            let url = (startPeriod !== 0 && endPeriod !== 0) ? `${pre_url}?start_period=${startPeriod}&end_period=${endPeriod}` : pre_url
            const response = await APIv1.get(url, {
                params: queryParams,
                headers: {
                    Authorization: `Token ${userData.token}`,
                }
            })
            const data = response.data.results.map(item => ({
                key: item.id,
                inn: item.inn,
                recipient: item.recipient,
                is_success: item.is_success,
                created_date: extractDateBySecond(item.created_date),
            }))
            setEmailData(data)
            setTotalEmail(response.data.count)
        } catch (err) {
            console.error('Something went wrong', err)
        } finally {
            setLoading(false)
        }
    }, [userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    useEffect(() => {
        fetchEmailData(tableState.currentPage, tableState.pageSize, tableState.search, tableState.ordering, tableState.filters)
    }, [tableState.currentPage, tableState.pageSize, tableState.search, tableState.ordering, tableState.filters, fetchEmailData, startPeriod, endPeriod])

    const tableChangeHandler = tableState.handleTableChange(columns);

    return (
        <>
            <div className='content_container'>
                <ListStateIndicator items={tableState.stateIndicators} onReset={tableState.resetState} onRemove={tableState.removeState}/>
                <Table
                    columns={controlledColumns}
                    dataSource={EmailData}
                    loading={loading}
                    onChange={(pagination, filters, sorter, extra) => {
                        tableChangeHandler(pagination, filters, sorter, extra);
                    }}
                    pagination={{
                        total: totalEmail,
                        current: tableState.currentPage,
                        pageSize: tableState.pageSize,
                        defaultPageSize: defaultPaginationSize,
                        showSizeChanger: true,
                        defaultCurrent: 1,
                        showTotal: (total, range) => `${range[0]} - ${range[1]} / ${total}`,
                        pageSizeOptions: ['10', '20', '50', '100'],
                    }}
                />
            </div>
        </>
    )
}

export default Email;
